import { render } from "./categoryForm.vue?vue&type=template&id=44aa5768"
import script from "./categoryForm.vue?vue&type=script&lang=js"
export * from "./categoryForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__